import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=66313678&"
import script from "./textarea.vue?vue&type=script&lang=ts&"
export * from "./textarea.vue?vue&type=script&lang=ts&"
import style0 from "./textarea.vue?vue&type=style&index=0&lang=scss&module=styleAnimation&"
import style1 from "./textarea.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleAnimation"] = (style0.locals || style0)
this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports